<template>
  <div>
    <SeasonsModal
      v-if="isShowSeasonsModal"
      @update:customRelatedPrograms="onUpdateCustomRelatedProgram"
      :customRelatedProgramIds="currentProgram.customRelatedProgramIds"
      :onClose="onToggleSeasonsModal"
      :goToFirstTab="goToFirstTab"/>
    <ConfirmModal
      v-if="confirmModal"
      :onClose="handleConfirmModal"
      :onConfirm="onDelete">
      <template v-slot:header-title>
        <h4>ยืนยันการลบ</h4>
      </template>
      <div>คุณยืนยันที่จะลบรายการ {{currentSeason.title}}</div>
    </ConfirmModal>
    <Section>
      <template v-slot:section-header>
        <h5 class="header-title m-0">ซีซัน</h5>
        <div class="action">
          <button class="btn btn-outline-primary" type="button" @click="onToggleSeasonsModal">
            <i class="fa fa-plus mr-1" />
            เพิ่มซีซันใหม่
          </button>
        </div>
      </template>
      <template v-slot:section-body>
        <div class="row program-item" v-for="(season, index) in customSeasons"
          :key="index"
          @click.stop="goToPageDetail(`/programs/${season.id}`, index-1, $event); goToFirstTab()">
          <ListItemSeason
            :image="season.coverImage"
            :listTitle="season.title"
            :listPrimaryInformation="getContentCategoryName(season)"
            :currentSeason="checkCurrentProgram(season)"
            v-show="index !== 0">
            <template v-slot:button-action>
              <button class="btn btn-light btn-action" type="button" @click.stop="handleConfirmModal(season)">
                <i class="fa fa-trash" />
              </button>
            </template>
          </ListItemSeason>
        </div>
        <EmptyMessage v-if="isShowingEmptyState">
          <div class="empty-message">ยังไม่มีซีซัน</div>
        </EmptyMessage>
      </template>
    </Section>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import Section from '@/components/Section.vue';
import ListItemSeason from '@/components/ListItemSeason.vue';
import dateFormetter from '@/utils/dateFormatter';
import EmptyMessage from '@/components/EmptyMessage.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import SeasonsModal from './SeasonsModal.vue';

export default {
  mixins: [dateFormetter],
  components: {
    Section,
    SeasonsModal,
    ListItemSeason,
    EmptyMessage,
    ConfirmModal,
  },
  props: {
    goToFirstTab: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isShowSeasonsModal: false,
      customRelatedPrograms: [],
      customSeasons: [],
      currentSeason: {},
      confirmModal: false,
    };
  },
  computed: {
    ...mapState({
      currentProgram: (state) => state.programItem.currentProgram,
      seasons: (state) => state.programItem.seasons,
    }),
    isShowingEmptyState() {
      if (!this.customSeasons) {
        return true;
      }
      if (this.customSeasons && this.customSeasons.length === 1) {
        return true;
      }
      return false;
    },
    programKey() {
      return this.$route.params.programKey;
    },
  },
  created() {
    this.customRelatedPrograms = _.cloneDeep(this.currentProgram.customRelatedPrograms);
    this.customSeasons = _.cloneDeep(this.seasons);
  },
  watch: {
    customRelatedPrograms(newProgram) {
      if (newProgram) {
        const customRelatedProgramIds = newProgram.map((program) => program.id);
        this.$store.dispatch('setCurrentProgram', { customRelatedPrograms: this.customRelatedPrograms, customRelatedProgramIds });
      }
    },
    // $route() {
    //   // console.log(this.programKey);
    //   // this.$store.dispatch('loadProgramByKey', this.programKey);
    // },
  },
  methods: {
    // async load() {
    //   await this.$store.dispatch('destroyCurrentProgram');
    //   await this.$store.dispatch('loadProgramByKey', this.programKey);
    // },
    onToggleSeasonsModal() {
      this.isShowSeasonsModal = !this.isShowSeasonsModal;
    },
    onUpdateCustomRelatedProgram(programs) {
      this.customRelatedPrograms = [...this.customRelatedPrograms, ...programs];
    },
    getContentCategoryName(program) {
      return _.get(program, 'contentCategory.name', '-');
    },
    onRemoveProgram(program) {
      const index = this.customRelatedPrograms.indexOf(program);
      if (index >= 0) {
        this.customRelatedPrograms.splice(index, 1);
      }
    },
    handleConfirmModal(season) {
      this.confirmModal = !this.confirmModal;
      if (season) {
        this.currentSeason = season;
      }
    },
    async onDelete() {
      const program = this.currentProgram;
      const season = this.currentSeason;
      await this.$store.dispatch('deleteProgram', season.id);
      if (program.id === season.id) {
        this.$router.push(`/programs/${program.parentProgramId}`);
        this.$store.dispatch('loadProgramByKey', program.parentProgramId);
      } else {
        this.$store.dispatch('loadProgramByKey', program.id);
      }
    },
    checkCurrentProgram(season) {
      if (this.programKey === season.id) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
